import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import enTranslations from "./locales/en.json";
import nlTranslations from "./locales/nl.json";

// Detect language from localStorage or URL path
const getLanguageFromPath = () => {
  if (typeof window !== "undefined") {
    try {
      const storedLang = window.localStorage.getItem("assessment_language");
      if (storedLang === "nl" || storedLang === "en") {
        return storedLang;
      }
    } catch (e) {
      // Ignore localStorage errors and fall back to URL
    }

    const path = window.location.pathname;
    const lang = path.split("/")[1];
    if (lang === "nl" || lang === "en") {
      return lang;
    }
  }
  return "en";
};

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: enTranslations,
      },
      nl: {
        translation: nlTranslations,
      },
    },
    lng: getLanguageFromPath(),
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;

